import { UserContext } from "contexts/UserContext";
import { useContext } from "react";
import { useDictionary } from "@adamlip/okeoke.client";
import VipFieldSwitch from "./VipFieldSwitch";
import CustomInput from "components/CustomInput";

export default function VipFields() {
  const { getValue } = useDictionary();

  const { userData } = useContext(UserContext);

  const { fields } = userData || {};

  const newFields = { ...fields, ...fields?.attributes };

  const newFieldsWithKeys = Object.entries(newFields).map((field) => {
    return { field: field[0], ...field[1] };
  });

  const filteredFields = newFieldsWithKeys
    .sort((a, b) => (a?.idx > b?.idx ? 1 : -1))
    .filter((field) => field.enabled);

  if (filteredFields.length < 1)
    return <div>{getValue("vip.fields.no.field")}</div>;

  return (
    <>
      <CustomInput
        isDisabled
        name="email"
        label={getValue("app_v2_profile_email")}
        value={userData?.email || ""}
      />
      {filteredFields.map((field) => (
        <VipFieldSwitch key={field.field} name={field.field} />
      ))}
    </>
  );
}
